import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";
import { getUrlToken, toQueryString } from '@ykz/ykz-util/base';
import cityComponts from '@/components/city.vue';
import shopNav from "./shopNav.vue";
export default {
  name: 'header',
  props: {
    shopName: {
      default: ''
    },
    showNav: {
      default: false
    },
    conditionId: {
      default: ''
    },
    onlyShowSelected: {
      default: 0
    },
    inPreview: {
      default: true
    }
  },
  components: {
    cityComponts: cityComponts,
    shopNav: shopNav
  },
  data: function data() {
    return {
      weChatId: getUrlToken('weChatId') || window.weChatId,
      fromWeChatId: getUrlToken('fromWeChatId') || 1,
      urlProvinceCode: window.getUrlParams('provinceCode'),
      urlCityCode: window.getUrlParams('cityCode'),
      urlDistrictCode: window.getUrlParams('districtCode'),
      cityDialowShow: false,
      hdMH: 0,
      beforeScrollTop: 0,
      nowScrollTop: 0,
      defaultPosition: null,
      showCity: false //加载城市组件
    };
  },

  filters: {
    _showShopName: function _showShopName(value) {
      return value.replace('店铺', '...');
    }
  },
  created: function created() {
    var that = this;
    // url指定进入页面时候的位置信息
    //有省份
    if (that.urlProvinceCode) {
      that.setProvince(that.urlProvinceCode);
    }
    //有城市
    if (that.urlCityCode) {
      that.setCity(that.urlCityCode);
    }
    if (that.urlDistrictCode) {
      that.setDistrict(that.urlDistrictCode);
    }
    that.showCity = true;
  },
  methods: {
    toPrmmoterSetting: function toPrmmoterSetting() {
      window.location.href = '/front/promoter/promoterSetting?' + toQueryString({
        weChatId: this.weChatId,
        fromWeChatId: this.fromWeChatId
      });
    },
    //切换城市
    submitCity: function submitCity(option) {
      $('#page').scrollTop(0);
      this.$emit('switchcity', option);
    },
    //展示城市弹窗
    getCityDialogShow: function getCityDialogShow(isShow) {
      this.cityDialowShow = isShow;
      if (isShow) {
        document.querySelector('#page').setAttribute('style', 'overflow: hidden');
      } else {
        document.querySelector('#page').removeAttribute('style');
      }
    },
    //页面滚动触发事件
    pageScroll: function pageScroll() {
      this.nowScrollTop = $('#page').scrollTop();
      // 向上滚动
      if (this.beforeScrollTop < this.nowScrollTop) {
        this.hdMH = this.hdMH + (this.beforeScrollTop - this.nowScrollTop);
        if (this.hdMH + $('#shopHeader').height() <= 0) {
          this.hdMH = 0 - $('#shopHeader').height();
        }
      }
      // 向下滚动
      if (this.beforeScrollTop > this.nowScrollTop) {
        this.hdMH = this.hdMH + (this.beforeScrollTop - this.nowScrollTop);
        if (this.hdMH >= 0) {
          this.hdMH = 0;
        }
      }
      //页面滚动到顶部
      if (this.nowScrollTop <= 0) {
        this.hdMH = 0;
      }
      this.beforeScrollTop = this.nowScrollTop;
    },
    //切换tab
    upDateNav: function upDateNav(option) {
      if ($('#page').scrollTop() > $('#shopHeader').height()) {
        this.beforeScrollTop = $('#shopHeader').height();
        $('#page').scrollTop(this.hdMH == 0 ? 0 : $('#shopHeader').height());
      }
      this.$emit('switchnav', option);
    },
    //获取用户数据
    getUserData: function getUserData(option) {
      this.$emit('getuserdata', option);
    },
    upDatePositionData: function upDatePositionData(data) {
      if (data) {
        this.defaultPosition = $.extend({
          provinceCode: '',
          provinceName: '',
          cityCode: '',
          cityName: '',
          districtCode: '',
          districtName: ''
        }, this.defaultPosition, data);
      }
      console.log(this.defaultPosition);
    },
    //设置默认省份
    setProvince: function setProvince(provinceCode) {
      var that = this;
      var data = window.iosProvinces.find(function (province) {
        return province.id == provinceCode;
      });
      if (data) {
        that.upDatePositionData({
          provinceCode: data.id,
          provinceName: data.value
        });
      }
    },
    //设置默认城市
    setCity: function setCity(cityCode) {
      var that = this;
      var data = window.iosCitys.find(function (city) {
        return city.id == cityCode;
      });
      if (data) {
        that.upDatePositionData({
          cityCode: data.id,
          cityName: data.value
        });
        that.setProvince(data.parentId);
      }
    },
    //设置默认省份
    setDistrict: function setDistrict(districtCode) {
      var that = this;
      var data = window.iosCountys.find(function (district) {
        return district.id == districtCode;
      });
      if (data) {
        that.upDatePositionData({
          districtCode: data.id,
          districtName: data.value
        });
        that.setCity(data.parentId);
      }
    }
  }
};